export default __webpack_public_path__ + "static/media/photo--lg--91.3ef51c89.jpg";